import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';
import { TraduccionesComponent } from '../../../../Alsa-MA-Angular-utils/src/app/traducciones.component';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var colorLineSelected: any;
declare var i18nVS: any;

// Variable que indica si se estan buscando las paradas de una linea
// Osea estara a true al clicar en una conexion
declare var searchForLineStops: any;
declare var lineId: any;
declare var lineName: any;
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var GetStopsFromLine: any;

declare var portletNameNearByLiferay: any;

declare var polylinePath: any;

declare function changeColorOfLineSelected(color);
declare function drawLine();
declare function cleanLine();

@Component({
    selector: 'app-near-by-paradas',
    templateUrl: './paradas.component.html',
    styleUrls: ['../near-by.component.css']
})

export class ParadasComponent {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = TraduccionesComponent.arrayTraducciones;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output () onLineSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output () onShowStops: EventEmitter<any> = new EventEmitter<any>();
    @Output () onHideStops: EventEmitter<any> = new EventEmitter<any>();

    jsonData; paradasCompleto = []; origen = ''; destino = '';
    paradas = [];
    linesJson;
    lineIdSelected;
    lineNameSelected;

    loadingStopsClass = '';
    showStopsClass = '';

    portletName = ''; // Nombre del portlet
    /*----------------------------------------------- Funciones ----------------------------------------------------*/

    leerDatos (): Observable<Response> {
        this.lineIdSelected = lineId;
        this.lineNameSelected = lineName;
        changeColorOfLineSelected(colorLineSelected);
        const body = 'cityId=' + idCiudadLiferay + '&' + portletNameNearByLiferay + 'lineId=' + lineId;
        const httpOptions = { 
            headers: new HttpHeaders({ 
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this.http.post(GetStopsFromLine, body, httpOptions);
    }

    public searchForLineStopsCorrutine () {
        if (searchForLineStops) {
            searchForLineStops = false;
            this.showStops();
            console.log("Buscando por las paradas de una linea!");
        }
        setTimeout(() => this.searchForLineStopsCorrutine(), 250);
    }

    public getBackground() {
        // Los colores de fondo de las paradas nos pueden llegar con el # incluido o sin el desde el back.
        // Para poder poner bien el color hacemos replace de # del 'color' que nos llega y se lo incluimos siempre.
        return this._sanitizer.bypassSecurityTrustStyle("#" + colorLineSelected.replace("#",""));
    }

    public setBackground(color) {
        return this._sanitizer.bypassSecurityTrustStyle("#" + color.replace("#",""));
    }

    public comprobandoJson (res) {
        try {
            this.jsonData = res;
            this.paradas = this.jsonData.stops;
            this.showStops2();
            console.log("Respuesta recibida: " + this.jsonData);
        } catch (error) {
            this.errorEnElJson();
        }
    }

    public errorEnElJson() {
        console.log('Error en los WS');
        this.onWebServiceError.emit(true);
    }

    /* Muestra las paradas de una linea */
    public showStops () {
        this.onShowStops.emit( lineId );
        this.loadingStopsClass = '';
        this.showStopsClass = "invisible";
        this.leerDatos().subscribe( res => this.comprobandoJson(res), (err) => this.errorEnElJson());
    }

    /* Muestra las paradas de una linea */
    public showStops2 () {
        // Limpiamos el array de conexiones
        this.paradas = this.clearConnections(this.paradas, lineId);
        this.loadingStopsClass = 'invisible';
        this.showStopsClass = "";

        this.origen = this.paradas[0].name;
        this.destino = this.paradas[this.paradas.length - 1].name;

        // Dibujamos la linea actual en el mapa
        polylinePath = [];
        for (var i=0; i < this.paradas.length; i++) {

            let longitude = this.paradas[i].long;
            if (typeof longitude == 'undefined') {
                longitude = this.paradas[i].lon;
            } if (typeof longitude == 'undefined') {
                longitude = this.paradas[i].longitude;
            }
            let latitude = this.paradas[i].lat;
            if (typeof latitude == 'undefined') {
                latitude = this.paradas[i].latitude;
            }

            var stop = ({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
            polylinePath.push(stop);
        }
        drawLine();
    }

    // Segundo paso de la funcion clearConnections
    private clearConnections (stops, lineId) {
        var newStops = stops;
        for (let i = 0; i < stops.length; i++) {
            var newConnections = [];
            var originalConnections = stops[i].connections;

            if (typeof originalConnections == 'undefined') {
                originalConnections = newConnections;
            }

            for (let x = 0; x < originalConnections.length; x++) {
                if (originalConnections[x].id != lineId) {
                    newConnections[newConnections.length] = originalConnections[x];
                }
            }

            // Se annaden las conexiones eliminando la propia linea
            newStops[i].connections = newConnections;
        }
        return newStops
    }

    /* Funcion cuando se selecciona una linea desde las conexiones */
    public lineSelected(connectionId, connectionName, connectionColor) {
        lineId = connectionId;
        colorLineSelected = connectionColor;
        lineName = this.getConectionsName(connectionName);
        this.showStopsClass = "invisible";
        this.loadingStopsClass = '';
        this.leerDatos().subscribe( res => this.comprobandoJson(res), (err) => this.errorEnElJson());
    }

    public setTraducciones() {
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
        }
    }

    public hideStops () {
        this.onHideStops.emit(true);
        cleanLine();
    }

    public getConectionsName(conectionName) {
        conectionName = conectionName.split(" ");
        return conectionName[0];
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameNearByLiferay;
        this.setTraducciones();
        this.searchForLineStopsCorrutine();
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(HttpClient) private http, private _sanitizer: DomSanitizer) { }
}



// WEBPACK FOOTER //
// ./src/app/paradas/paradas.component.ts